const Camera = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      d="M2 5.5h2.5l1-2h5l1 2H14V13H2z"
      stroke={stroke}
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="9" r="2.4" stroke={stroke} strokeWidth="1.4" />
  </svg>
);

export default Camera;
